import { Component, ViewChild, ElementRef, HostListener, Renderer2, ViewEncapsulation, OnInit, AfterViewInit, OnDestroy, DestroyRef, inject } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { MatMenuTrigger } from '@angular/material/menu';
import { Overlay } from '@angular/cdk/overlay';
import { ModalController } from '@ionic/angular';
import { DateTime as LuxonDateTime } from 'luxon';
import { FormBuilder, UntypedFormGroup } from '@angular/forms';
import { debounceTime, take } from 'rxjs/operators';
import { Subscription } from 'rxjs';
import { CdkDragDrop } from '@angular/cdk/drag-drop';
import { scrollContentWidth } from 'src/shared/components/scroll-wrapper/scroll-wrapper.component';
import * as confetti from 'canvas-confetti';
import { spookyConfetti } from 'src/shared/util/halloween';
import { CdkVirtualScrollViewport } from '@angular/cdk/scrolling';
import { ActivatedRoute, Router } from '@angular/router';

import { Client } from 'src/providers/client/client';
import { CustomNavController } from 'src/shared/providers/navigation/custom-nav-controller';
import { CurrentAddress } from 'src/providers/addresses/current-address';
import { Events } from 'src/providers/events/events';
import { ReportIssue } from 'src/providers/report-issue/report-issue';
import { TidyStorage } from 'src/shared/providers/tidy-storage';
import { WindowService } from 'src/shared/providers/window.service';
import { Pros } from 'src/providers/pros/pros';
import { Schedule } from 'src/providers/schedule/schedule';
import { RightSidePanelService } from 'src/shared/providers/providers/right-side-panel';
import { UserService } from 'src/providers/user/user';
import { HttpClientCustom } from 'src/providers/custom/http-client';
import { Genome } from 'src/providers/genome/genome';
import { MaintenanceSuggestionsService, MaintenanceSuggestion } from 'src/shared/services/maintenance-suggestions.service';

import { Loading } from 'src/shared/components/loading/loading';

import { ConfirmPage, ConfirmPageParamsModel } from 'src/pages/confirm/confirm.component';
import { BREAK_LARGE_RESOLUTION } from 'android/app/src/constants/app.contants';
import { TasksFilter } from 'src/pages/tasks/tasks-filter/tasks-filter';

import { TaskPage } from 'src/pages/tasks/task/task';
import { SuggestionPage } from 'src/pages/tasks/suggestion/suggestion';
import { CreateActionPlanPage } from './create-action-plan/create-action-plan';

import { TranslationPipe } from 'src/shared/pipes/translation.pipe';
import { ParseDateTimePipe } from 'src/shared/pipes/parse-date.pipe';
import { OnboardingProvider } from 'src/providers/onboarding/onboarding.provider';
import { Util } from 'src/shared/util/util';
import { getTaskStatusLabel } from 'src/shared/util/task-status-label';
import { TitleCasePipe } from '@angular/common';
import { BookService } from 'src/shared/services/book.service';
import { PastPrivateJobPage } from 'src/pages/more/past-private-job/past-private-job';
import { PastJobPage } from 'src/pages/more/past-job/past-job';
import { JobPage } from 'src/pages/schedule/job/job';
import { DemoBlockService } from 'src/shared/services/demo-block.service';

@Component({
  templateUrl: 'tasks.html',
  styleUrls: ['./tasks.scss'],
  encapsulation: ViewEncapsulation.None,
  standalone: false
})

export class TasksPage implements OnInit, AfterViewInit, OnDestroy {
  private destroyRef = inject(DestroyRef);

  @ViewChild(CdkVirtualScrollViewport) viewport: CdkVirtualScrollViewport;
  @ViewChild('urgencyMenuTrigger') urgencyMenuTrigger: MatMenuTrigger;
  @ViewChild('addressMenuTrigger') addressMenuTrigger: MatMenuTrigger;
  @ViewChild('mobileUserMenuTrigger') mobileUserMenuTrigger: MatMenuTrigger;
  @ViewChild('desktopUserMenuTrigger1') desktopUserMenuTrigger1: MatMenuTrigger;
  @ViewChild('desktopUserMenuTrigger2') desktopUserMenuTrigger2: MatMenuTrigger;
  @ViewChild('desktopUserMenuTrigger3') desktopUserMenuTrigger3: MatMenuTrigger;
  @ViewChild('desktopJobMenuTrigger') desktopJobMenuTrigger: MatMenuTrigger;
  @ViewChild('desktopJobMenuTrigger2') desktopJobMenuTrigger2: MatMenuTrigger;
  @ViewChild('mobileJobMenuTrigger') mobileJobMenuTrigger: MatMenuTrigger;
  addressResponse: any = [];
  addressesIndexedById: any;
  addressesMenu: any;
  addressId: any;
  addressFilter: any;
  cards: any;
  categories: any;
  backPage: string | null;
  dontGoToIssueDetail: boolean;
  errorMessage: string;
  isDragging: boolean;
  issues: any;
  issuesColumns: any;
  issueReportTypes: any = [];
  isAllAddressesSelected: boolean;
  initAddressFilterValue: any;
  initialAddressFilter: string[] = [];
  loggedIssuesResponse: any;
  selectedStatus: any;
  readonly desktopWidthContent: string = scrollContentWidth.LARGE;
  columns: string[] = ['reported', 'approved', 'in_progress', 'done'];
  // First-load skeleton: varied card counts per column so the placeholder
  // board reads like a real one (New fullest, Doing lightest).
  readonly skeletonBoard: number[][] = [
    [1, 2, 3, 4, 5, 6, 7],
    [1, 2, 3, 4, 5],
    [1, 2, 3],
    [1, 2, 3, 4, 5, 6]
  ];
  readonly columnTitlesByKeys: any = {
    reported: new TranslationPipe().transform('New'),
    approved: new TranslationPipe().transform('Approved'),
    in_progress: new TranslationPipe().transform('Doing'),
    done: new TranslationPipe().transform('Done')
  };
  isMobileResolution: boolean;
  selectedFilters: TasksFilter;
  urgencyFilter = [{viewValue: new TranslationPipe().transform('All Urgencies'), value: -1}, {viewValue: new TranslationPipe().transform('Low'), value: 'low'}, {viewValue: new TranslationPipe().transform('Normal'), value: 'normal'}, {viewValue: new TranslationPipe().transform('Emergency'), value: 'emergency'}];
  typeFilter;
  showLoadingSpinner: boolean;
  selectedUrgency: any;
  selectedType: any;
  rootRef: Promise<ElementRef>;
  members: any;
  urgencies: any;
  form: UntypedFormGroup;
  jobSearchForm: UntypedFormGroup;
  loadingActionSuggestions: boolean;
  conciergeActionSuggestions: { issue_report_id: number, suggestions: any[] };
  loaded: boolean;
  searchTerm: string;
  filteredIssues: any[];
  private panelClosedSubscription: Subscription;
  showOnboarding: boolean;
  hasProperties: boolean;
  routerParams: any;
  hasAssets = false;
  hideSuggestedCard = false;
  maintenanceSuggestions: MaintenanceSuggestion[] = [];

  constructor(
    private client: Client,
    private currentAddress: CurrentAddress,
    private events: Events,
    private modalCtrl: ModalController,
    private navCtrl: CustomNavController,
    private pros: Pros,
    private reportIssue: ReportIssue,
    private storage: TidyStorage,
    public windowService: WindowService,
    private fb: FormBuilder,
    private renderer2: Renderer2,
    private elementRef: ElementRef,
    public httpClient: HttpClientCustom,
    private router: Router,
    private rightSidePanelService: RightSidePanelService,
    private schedule: Schedule,
    private userService: UserService,
    public onboardingProvider: OnboardingProvider,
    public util: Util,
    private route: ActivatedRoute,
    private overlay: Overlay,
    private genome: Genome,
    private maintenanceSuggestionsService: MaintenanceSuggestionsService,
    private bookService: BookService,
    private demoBlock: DemoBlockService
  ) {
    this.form = this.fb.group({
      search: [''],
    });
    this.jobSearchForm = this.fb.group({
      search: ['']
    });
    this.jobSearchForm.valueChanges
      .pipe(debounceTime(300), takeUntilDestroyed(this.destroyRef))
      .subscribe((val) => this.updateJobSearch(val));
  }

  @HostListener("window:resize", ["$event"])
  onResize(event) {
    this.isMobileResolution = event.target.innerWidth <= BREAK_LARGE_RESOLUTION;
  }

  async ngOnInit() {
    try {
      this.route.params.pipe(takeUntilDestroyed(this.destroyRef)).subscribe(params => {
        this.routerParams = params;
      });
      this.onboardingProvider.showOnboarding = false;
      await this.loadPage();
    } catch (err) {
      this.errorMessage = err?.error?.message ?? err?.message;
    }
  }

  async loadPage(showLoadingSpinner = false, setStoredRoute = true) {
    if (showLoadingSpinner) {this.showLoadingSpinner = true;}
    const shouldClearLocalStorage = !this.windowService.isDesktopRes || showLoadingSpinner;
    await this.getData(shouldClearLocalStorage);
    this.loaded = true
    this.showLoadingSpinner = false;
    /*setTimeout(() => {
      this.loaded = true; //Delay setting loaded to TRUE to ensure cdk-virtual-scroll-viewport works with hundreds of tasks
    }, 100);*/
    if (this.windowService.isDesktopRes && setStoredRoute) {
      this.storage.setStoredRoute('/maintenance').then(async () => {
        this.onboardingProvider.showOnboarding = false;
        await this.loadPage(true);
      });
    }
  }

  async getData(shouldClearLocalStorage = true, preserveFilters = false) {
    if (!preserveFilters) {
      this.selectedStatus = 'reported';
    }
    this.addressResponse = await this.client.getMoreDetailAddresses();
    this.addressId = await this.client.getSelectedAddressId(this.addressResponse);
    if (!preserveFilters) {
      this.initialAddressFilter = [];
      this.selectedFilters = {
        propertyName: [],
        type: [],
        urgency: [],
        address: []
      };
    }
    const savedAddressId = localStorage.getItem('maintenanceAddressId');
    if (savedAddressId) {
      this.addressId = Number(savedAddressId);
      this.initialAddressFilter = [savedAddressId];
      this.selectedFilters = {
        propertyName: [savedAddressId],
        type: [],
        urgency: [],
        address: []
      };
      localStorage.removeItem('maintenanceAddressId');
    }
    this.backPage = localStorage.getItem('loggedIssuesBackPage');
    this.categories = await this.pros.getServiceCategories();
    this.reportIssue.getIssueReportTypes().then((res) => {
      this.issueReportTypes = res;
      this.typeFilter = res.map((type) => ({
          viewValue: new TranslationPipe().transform(type.name),
          value: type.id
        }));
    });
    this.addressFilter = await this.navCtrl.getParam('addressFilter') || await this.buildAddressFilter();
    this.urgencies = this.getUrgencies();
    this.isAllAddressesSelected = localStorage.getItem('isAllAddressesSelected') === 'true';
    await this.getLoggedIssues();
    await this.parseUsersAndJobs();
    await this.checkForAssets();
    await this.fetchMaintenanceSuggestions();
    if (this.routerParams?.taskId) {
      const issue = this.findIssueById(this.routerParams.taskId);
      if (issue) {
        this.goToTask(issue);
      } else {
        const foundIssue = await this.reportIssue.getIssueReport(this.routerParams.taskId);
        if (foundIssue?.archived_at) {
          this.router.navigate(['/archived-maintenance', foundIssue.address_id, this.routerParams.taskId]);
        } else {
          this.router.navigate(['/maintenance', foundIssue.address_id, this.routerParams.taskId]);
        }
      }
      this.routerParams = null;
    }
    this.closeAnyOpenMenu();
  }

  closeAnyOpenMenu() {
      this.closeAllMenus();
      const menuTriggers = [
        this.urgencyMenuTrigger,
        this.addressMenuTrigger,
        this.mobileUserMenuTrigger,
        this.desktopUserMenuTrigger1,
        this.desktopUserMenuTrigger2,
        this.desktopUserMenuTrigger3,
        this.desktopJobMenuTrigger,
        this.desktopJobMenuTrigger2,
        this.mobileJobMenuTrigger
      ];
      menuTriggers.forEach((trigger, _index) => {
        try {
          if (trigger && trigger.menuOpen) {
            trigger.closeMenu();
          }
        } catch (_error) {
          // Silent error - menu close failure is not critical
        }
      });
      setTimeout(() => {
        const remainingBackdrops = document.querySelectorAll('.cdk-overlay-backdrop');
        if (remainingBackdrops.length > 0) {
          const escEvent = new KeyboardEvent('keydown', {
            key: 'Escape',
            keyCode: 27,
            which: 27,
            bubbles: true,
            cancelable: true
          });
          document.dispatchEvent(escEvent);
          document.body.dispatchEvent(escEvent);
        }
    }, 50);
  }

  findIssueById(issueId: number) {
    for (const column of this.columns) {
      if (this.issuesColumns[column]) {
        const issue = this.issuesColumns[column].find((iss: any) => iss.id === Number(issueId));
        if (issue) {
          return issue;
        }
      }
    }
    return null;
  }

  getUrgencies() {
    return [
      {
        value: 'low',
        viewValue: 'Low',
        icon: 'assets/img/low_priority.svg'
      },
      {
        value: 'normal',
        viewValue: 'Normal',
        icon: 'assets/img/normal_priority.svg'
      },
      {
        value: 'high',
        viewValue: 'High',
        icon: 'assets/img/high_priority.svg'
      },
      {
        value: 'emergency',
        viewValue: 'Emergency',
        icon: 'assets/img/emergency_priority.svg'
      }
    ];
  }

  async parseUsersAndJobs() {
    const allUsersResponse = await this.userService.getUsersList();
    const allUsers = [];
    allUsersResponse.map((user) => {
      allUsers.push({
        name: `${user.first_name  } ${  user.last_name}`,
        id: user.id
      });
    });
    this.storage.save('allUsers', allUsers);
    this.columns.forEach((column) => {
      if (!Array.isArray(this.issuesColumns[column])) {
        return;
      }
      this.issuesColumns[column].forEach((issue) => {
        issue['checkedJobs'] = this.getCheckedJobs(issue);
        issue['allUsers'] = [];
        allUsers.map((user) => {
          const addedUser = issue.members.find((member) => member.id === user.id);
          const userObject = {
            checked: !!addedUser,
            name: user.name,
            id: user.id
          }
          if (addedUser) {
            userObject['attachmentId'] = addedUser.attachment_id;
          }
          issue['allUsers'].push(userObject);
        });
        issue['allUsers'].unshift({
          name: 'Concierge',
          id: 0,
          checked: issue.assigned_to_concierge
        });
        issue['checkedUsers'] = issue['allUsers'].filter((user) => user.checked);
      });
    });
  }

  async checkOrUncheckPerson(task, user, event) {
    if (this.demoBlock.block()) { return; }
    if (this.windowService.isDesktopRes) {
      // Close all desktop user menu triggers since we don't know which one was opened
      this.desktopUserMenuTrigger1?.closeMenu();
      this.desktopUserMenuTrigger2?.closeMenu();
      this.desktopUserMenuTrigger3?.closeMenu();
    } else {
      this.mobileUserMenuTrigger.closeMenu();
    }
    if (user.name === 'Concierge') {
      if (!event.checked) {
        this.reportIssue.updateIssueReport(task.id, {assigned_to_concierge: false});
      } else {
        this.goToCreateActionPlan(task);
      }
    } else {
      if (event.checked) {
        const payload = {
          issue_report_id: task.id,
          attachable_id: user.id,
          attachable_type: 'CustomerMember'
        }
        const attachmentResponse = await this.reportIssue.addIssueReportAttachment(payload);
        user['attachmentId'] = attachmentResponse.attachment_id;
      } else {
        await this.reportIssue.deleteIssueReportAttachment(user['attachmentId']);
      }
    }
    const userIndex = task['checkedUsers'].findIndex((checkedUser) => checkedUser.id === user.id);
    if (userIndex !== -1) {
      task['checkedUsers'].splice(userIndex, 1);
    } else {
      const checkedUser = {
        id: user.id,
        name: user.name,
        checked: event.checked
      }
      task['checkedUsers'].push(checkedUser);
    }
    this.storage.delete('tasksLastSavedAt');
  }

  getCheckedJobs(issue) {
    const checkedJobs = [];
    issue.bookings.map((booking) => {
      // Format date time
      const dateTime = new ParseDateTimePipe().transform(booking.job_data.start_datetime_local, 'MMM d h:mma');

      // Get homekeeper name
      const homekeeperName = booking.job_data?.homekeeper_jobs?.[0]?.homekeeper?.name || '';

      // Simple display: date/time - pro name (if present)
      const displayName = homekeeperName ? `${dateTime} - ${homekeeperName}` : dateTime;

      checkedJobs.push({
        ...booking,
        id: booking.id,
        job_id: booking.job_data?.id,
        name: displayName,
        checked: true,
        icon_url: booking.job_data.service_icon_url,
        status: this.reportIssue.getJobStatusData(booking.job_data.homekeeper_jobs, booking.job_data.job_progress),
        attachmentId: booking.attachment_id,
        start_datetime_local: booking.start_datetime_local,
        is_private: booking?.job_data?.is_private,
        service_name: booking.job_data.service_name,
      });
    });
    return checkedJobs;
  }

  @Loading('', true)
  async showJobMenu(event, issue) {
    event.stopPropagation();
    if (!issue['allJobs']) {
      const jobs = await this.schedule.getJobs(issue.address_id);
      const timezone = this.getTimezoneForAddress(issue.address_id)
      issue['allJobs'] = jobs.map((job) => {
        const addedJob = issue.bookings.find((booking) => booking.id === job?.booking?.id);

        // Format date and time
        const dateTime = `${job.date} ${job.start_time}`;

        // Get homekeeper name if available
        const homekeeperName = job?.homekeeper_jobs?.[0]?.homekeeper?.name || '';

        // Simple display: date/time - pro name (if present)
        const displayName = homekeeperName ? `${dateTime} - ${homekeeperName}` : dateTime;

        return {
          id: job.booking?.id,
          job_id: job.id,
          name: displayName,
          icon_url: job.service_icon_url,
          checked: !!addedJob,
          attachmentId: addedJob ? addedJob.attachment_id : null,
          // Keep minimal fields needed by other functions
          status: this.reportIssue.getJobStatusData(job.homekeeper_jobs, job.job_progress),
          start_datetime_local: job.date,
          is_private: job?.template_data?.job?.is_private,
          service_name: job?.template_data?.job?.service_type_details?.name,
        };
      });
      issue.bookings.map((booking) => {
        const job = issue['allJobs'].find((allJob) => allJob.id === booking?.id);
        const jobIsScheduled = !!job;
        if (!jobIsScheduled) {
          const checkedJob = issue['checkedJobs'].find((item) => item.id === booking?.id);
          if (checkedJob) {
            checkedJob['isPastJob'] = true;
          }

          const dateTime = new ParseDateTimePipe().transform(booking.job_data.start_datetime_local, 'MMM d h:mma');
          const homekeeperName = booking.job_data?.homekeeper_jobs?.[0]?.homekeeper?.name || '';
          const displayName = homekeeperName ? `${dateTime} - ${homekeeperName}` : dateTime;

          issue['allJobs'].unshift({
            isPastJob: true,
            id: booking.id,
            job_id: booking.job_data?.id,
            name: displayName,
            checked: true,
            icon_url: booking.job_data.service_icon_url,
            status: this.reportIssue.getJobStatusData(booking.job_data.homekeeper_jobs, booking.job_data.job_progress),
            attachmentId: booking.attachment_id,
            start_datetime_local: booking.start_datetime_local,
            is_private: booking?.job_data?.is_private,
            service_name: booking.job_data.service_name,
          });
        }
      });
    }

    // Set filteredJobs for the template to display
    issue['filteredJobs'] = issue['allJobs'];

  }

  getTimezoneForAddress(addressId) {
    const address = this.addressResponse.find((addr) => addr.id === addressId);
    return address.timezone;
  }

  async checkOrUncheckJob(task, job, event) {
    if (this.demoBlock.block()) { return; }
    if (event.checked) {
      const payload = {
        issue_report_id: task.id,
        attachable_id: job.id,
        attachable_type: 'Booking'
      }
      const attachmentResponse = await this.reportIssue.addIssueReportAttachment(payload);
      job['attachmentId'] = attachmentResponse.attachment_id;
      job['status'] = this.reportIssue.getJobStatusData(attachmentResponse.job_data.homekeeper_jobs, attachmentResponse.job_data.job_progress);
    } else {
      await this.reportIssue.deleteIssueReportAttachment(job['attachmentId']);
    }
    const jobIndex = task['checkedJobs'].findIndex((checkedJob) => checkedJob.id === job.id);
    if (jobIndex !== -1) {
      task['checkedJobs'].splice(jobIndex, 1);
    } else {
      const checkedJob = {
        ...job
      }
      task['checkedJobs'].push(checkedJob);
    }
    this.storage.delete('tasksLastSavedAt');
  }

  selectUrgency(task, urgency) {
    if (this.demoBlock.block()) { return; }
    this.urgencyMenuTrigger.closeMenu();
    task['urgency'] = urgency.value;
    this.updateTask(task);
  }

  async selectAddress(task, address) {
    if (this.demoBlock.block()) { return; }
    this.addressMenuTrigger.closeMenu();
    if (task.address_id !== address.value && task.checkedJobs.length > 0) {
      await Promise.all(task.checkedJobs.map(async (job) => {
        if (job['attachmentId']) {
          await this.reportIssue.deleteIssueReportAttachment(job['attachmentId']);
        }
      }));
    }
    task['allJobs'] = null;
    task['checkedJobs'] = [];
    task['address_id'] = address.value;
    this.updateTask(task);
  }

  @Loading('', true)
  async updateTask(task) {
    const payload = {
      title: task.title,
      description: task.description,
      urgency: task.urgency,
      address_id: task.address_id,
      status: task.status,
      issue_report_type_id: task.issue_report_type.id
    }
    task = await this.reportIssue.updateIssueReport(task.id, payload);
    this.storage.delete('tasksLastSavedAt');
  }

  async buildAddressFilter() {
    this.addressResponse = await this.client.getAddresses();
    this.storage.save('addressResponse', this.addressResponse);
    this.addressesIndexedById = this.addressResponse?.reduce((acc, address) => {
      acc[address.id] = address;
      return acc;
    }, {});
    this.storage.save('addressesIndexedById', this.addressesIndexedById)
    return this.client.parseAddressList(this.addressResponse, false);
  }

  async getLoggedIssues() {
    try {
      this.loggedIssuesResponse = (await this.reportIssue.getIssueReports()).sort((a, b) => a.display_order - b.display_order);
      this.loggedIssuesResponse = this.loggedIssuesResponse.filter((task) => !task.archived_at);
      this.onFilterChanges({
        selectedFilters: this.selectedFilters,
        lastSelectedFilter: null
      });
    } catch (err) {
      this.errorMessage = (err.error && err.error.message) ? err.error.message : err.message;
    }
  }

  loadIssueColumns(search = '', filteredIssues = this.loggedIssuesResponse) {
    search = search.toLowerCase()
    if (search.length > 0) {
      filteredIssues = filteredIssues.filter((issue) => issue.description.toLowerCase().includes(search) ||
               issue.issue_report_type.name.toLowerCase().includes(search) ||
               issue.title.toLowerCase().includes(search));
    }

    this.issuesColumns = {
      reported: [],
      approved: [],
      in_progress: [],
      done: []
    };

    this.columns.forEach((column) => {
      this.issuesColumns[column] = filteredIssues
        .filter((issue) => issue.status === column)
        .sort((a, b) => a.display_order - b.display_order);
    });

    let showTestData = false;
    this.issuesColumns.reported.map((issue) => {
      if (issue.description === 'test123') {
        localStorage.setItem('showTestData', 'true');
        localStorage.setItem('taskIndex', '0');
        showTestData = true;
      }
    });
    if (!showTestData) {
      localStorage.setItem('showTestData', 'false');
    }
  }

  logIssue() {
    const params: any = {
      addressFilter: this.addressFilter
    }
    if (this.addressId !== -1 && !this.isAllAddressesSelected) {
      params['addressId'] = this.addressId;
    }
    this.navCtrl.navigateForward('log-issue', params);
  }

  updatedStatusFilter(status) {
    this.selectedStatus = status;
    this.issues = this.loggedIssuesResponse.filter((item) => item.status === status);
  }

  async markIssueAsResolved(issue) {
    const params: ConfirmPageParamsModel = {
      title: 'Mark Resolved?',
      body: 'You cannot undo this action.',
      backText: 'Go Back',
      confirmText: 'Resolve',
      confirmAction: this.confirmMarkIssueResolved.bind(this),
      confirmActionParams: issue
    }
    const confirmationModal = await this.modalCtrl.create({
      component: ConfirmPage,
      componentProps: params,
      animated: false,
      cssClass: 'confirm-modal'
    });
    await confirmationModal.present();
  }

  async confirmMarkIssueResolved(issue) {
    try {
      await this.reportIssue.resolveReportedIssue(issue?.id);
      await this.getLoggedIssues();
      this.modalCtrl.dismiss();
    } catch (err) {
      this.errorMessage = (err.error && err.error.message) ? err.error.message : err.message;
      throw err;
    }
  }

  async deleteIssue(issue) {
    const params: ConfirmPageParamsModel = {
      title: 'Delete Issue?',
      body: 'You cannot undo this action.',
      backText: 'Go Back',
      confirmText: 'Delete',
      confirmAction: this.confirmDeleteIssue.bind(this),
      confirmActionParams: issue
    }
    const confirmationModal = await this.modalCtrl.create({
      component: ConfirmPage,
      componentProps: params,
      animated: false,
      cssClass: 'confirm-modal'
    });
    await confirmationModal.present();
  }

  getUserInitials(user) {
    return user.name.split(' ').map(part => part[0]).join('').toUpperCase();
  }

  async goToTask(issue) {
    try {
      if (this.dontGoToIssueDetail) {
        return;
      }
      if (this.demoBlock.block()) { return; }
      this.checkIfCheckedJobsInPast(issue);
      const params = {
        issue,
        addressResponse: this.addressResponse,
        issueReportTypes: this.issueReportTypes,
        categories: this.categories
      }
      this.storage.save('dialog-right-side-open', true);
      this.storage.save('dialog-params', params);
      if (this.windowService.isDesktopRes) {
        this.rightSidePanelService.openRightSidePanel(TaskPage);
        this.rightSidePanelService.setDialogPageTitle('Task');
        this.rightSidePanelService.panelClosed().pipe(take(1), takeUntilDestroyed(this.destroyRef)).subscribe(async () => {
          const tasksLastSavedAt = await this.storage.retrieve('tasksLastSavedAt');
          if (!tasksLastSavedAt) {
            this.showLoadingSpinner = true;
            await this.getData(true, true);
            this.showLoadingSpinner = false;
          }
        });
      } else {
        this.navCtrl.navigateForward('task')
      }
    } catch (err) {
      this.errorMessage = (err.error && err.error.message) ? err.error.message : err.message;
    }
  }

  async goToCreateActionPlan(task) {
    try {
      // Fetch full task data for action plan since list only has minimal includes
      const fullIssueData = await this.reportIssue.getIssueReport(task.id);

      const params = {
        issue: fullIssueData,
        issueAddress: this.addressesIndexedById[task.address_id],
      }
      this.storage.save('dialog-right-side-open', true);
      this.storage.save('dialog-params', params);
      if (this.windowService.isDesktopRes) {
        this.rightSidePanelService.openRightSidePanel(CreateActionPlanPage);
        this.rightSidePanelService.panelClosed().pipe(take(1), takeUntilDestroyed(this.destroyRef)).subscribe(async () => {
          this.showLoadingSpinner = true;
          await this.getData(true, true);
          this.showLoadingSpinner = false;
        });
      } else {
        this.navCtrl.navigateForward('create-action-plan', params)
      }
    } catch (_err) {
      // Silent error handling - navigation failure is not critical
    }
  }

  checkIfCheckedJobsInPast(issue) {
    issue?.bookings?.map((booking) => {
      const job = issue['allJobs']?.find((j) => j?.id === booking?.id);
      const jobIsScheduled = !!job;
      if (!jobIsScheduled) {
        const checkedJob = issue['checkedJobs']?.find((j) => j?.id === booking?.id);
        if (checkedJob) {
          checkedJob['isPastJob'] = true;
        }
      }
    });
  }

  async confirmDeleteIssue(issue) {
    try {
      await this.reportIssue.deleteReportedIssue(issue?.id);
      await this.getLoggedIssues();
      this.modalCtrl.dismiss();
    } catch (err) {
      this.errorMessage = (err.error && err.error.message) ? err.error.message : err.message;
      throw err;
    }
  }

  getIssueHeaderIcon(issue) {
    if (!issue) {return '';}
    const icons = {
      'low': 'assets/img/low_priority.svg',
      'normal': 'assets/img/normal_priority.svg',
      'high': 'assets/img/high_priority.svg',
      'emergency': 'assets/img/emergency_priority.svg'
    };
    return icons[issue.urgency];
  }

  @Loading('', true)
  async changeAddress(selectedAddressId) {
    this.addressId = selectedAddressId;
    if (selectedAddressId === 0) {
      return this.navCtrl.navigateForward('add-property');
    }
    try {
      if (selectedAddressId !== -1) {
        this.isAllAddressesSelected = true;
        this.currentAddress.addressId = selectedAddressId.toString();
      }
      await this.getLoggedIssues();
    } catch (err) {
      this.errorMessage = (err.error && err.error.message) ? err.error.message : err.message;
    }
  }

  async changeUrgency(selectedUrgency) {
    this.selectedUrgency = selectedUrgency;
    await this.getLoggedIssues();
  }

  getRelativeDateFromISO(date, addressId) {
    const address = this.addressResponse?.find((addr) => addr?.id === addressId);
    if (!address) {return '';}
    const relative = LuxonDateTime.fromISO(date, {zone: 'utc'}).setZone(address?.timezone).toRelative();
    if (!relative) {return '';}
    const matches = relative.match(/^(\d+)\s+(\w+)\s+ago$/);
    if (matches) {
      const [_, number, unit] = matches;
      return `${number} ${new TranslationPipe().transform(unit)} ${new TranslationPipe().transform('ago')}`;
    }
    return relative;
  }

  getAddressName(task) {
    if (!task.address_id) {return '';}
    const address = this.addressesIndexedById[task.address_id];
    const addressName = address?.address_name || `${address?.address1}${address?.address2 ? `, ${  address.address2}` : ''}`;

    const isDesktopRes = this.windowService.windowSize > 1535;
    if (isDesktopRes) {
      return addressName.length > 20 ? `${addressName.slice(0, 20)  }..` : addressName;
    }

    let maxLength;
    if (task.checkedJobs?.length > 1) {
      maxLength = 10;
    } else if (task.checkedJobs?.length === 1) {
      maxLength = 12;
    } else {
      maxLength = 20;
    }

    return addressName.length > maxLength ? `${addressName.slice(0, maxLength)  }..` : addressName;
  }

  goToAddressPage(addressId) {
    this.navCtrl.navigateForward(`properties?propertyId=${addressId}`);
  }

  onFilterChanges(value) {
    if (!this.loggedIssuesResponse) {
      return;
    }
    if (!value.selectedFilters) {
      this.selectedFilters = {
        propertyName: [],
        type: [],
        urgency: [],
        address: []
      };
      this.loadIssueColumns(this.searchTerm, this.loggedIssuesResponse);
      return;
    }
    const hasNoFilter = !value.selectedFilters.propertyName.length && !value.selectedFilters.type.length && !value.selectedFilters.urgency.length;
    this.selectedFilters = value.selectedFilters;
    let filteredIssues = [];
    if (!hasNoFilter) {
      this.loggedIssuesResponse.filter((task) => {
        let isCorrectAddress = this.selectedFilters.propertyName.length === 0;
        let isCorrectType = this.selectedFilters.type.length === 0;
        let isCorrectUrgency = this.selectedFilters.urgency.length === 0;
        this.selectedFilters.propertyName.map((addressId) => {
          if (task.address_id === Number(addressId)) {
            isCorrectAddress = true;
          }
        });
        this.selectedFilters.type.map((typeId) => {
          if (task.issue_report_type.id === Number(typeId)) {
            isCorrectType = true;
          }
        });
        this.selectedFilters.urgency.map((urgency) => {
          if (task.urgency === urgency) {
            isCorrectUrgency = true;
          }
        });
        if (isCorrectAddress && isCorrectType && isCorrectUrgency) {
          filteredIssues.push(task);
        }
      });
    } else {
      filteredIssues = this.loggedIssuesResponse;
    }
    this.filteredIssues = filteredIssues;
    this.loadIssueColumns(this.searchTerm, filteredIssues);
  }

  onSearchChanges(value) {
    this.searchTerm = value.search;
    this.loadIssueColumns(this.searchTerm, this.filteredIssues);
  }

  async addIssueReport() {
    if (this.demoBlock.block()) { return; }
    if (localStorage.getItem('hasAtLeastOneAddress') !== 'true') {
      return this.util.showError('Please add a property to add maintenance');
    }
    const params = {
      addressResponse: this.addressResponse,
      issueReportTypes: this.issueReportTypes
    }
    this.storage.save('dialog-right-side-open', true);
    this.storage.save('dialog-params', params);
    if (this.windowService.isDesktopRes) {
      this.rightSidePanelService.openRightSidePanel(TaskPage);
      this.rightSidePanelService.setDialogPageTitle('Add Task');
      this.rightSidePanelService.panelClosed().pipe(take(1), takeUntilDestroyed(this.destroyRef)).subscribe(async () => {
        const tasksLastSavedAt = await this.storage.retrieve('tasksLastSavedAt');
        if (!tasksLastSavedAt) {
          this.showLoadingSpinner = true;
          await this.getData(true, true);
          this.showLoadingSpinner = false;
        }
      });
    } else {
      this.navCtrl.navigateForward('task')
    }
  }

  async dropped(dropped: CdkDragDrop<any>) {
    if (this.demoBlock.block()) { return; }
    const issueData = dropped.item.data;
    const newStatus = dropped.container.id;
    const srcColumn = this.issuesColumns[dropped.item.data.status]
    const targetColumn = this.issuesColumns[newStatus];
    let newOrder = targetColumn[dropped.currentIndex]?.display_order
    if (targetColumn === srcColumn) {
      newOrder += (dropped.currentIndex < dropped.previousIndex ? -1 : 1);
    }
    if (!newOrder && newOrder !== 0) {
      newOrder = targetColumn[targetColumn?.length - 1]?.display_order + 1;
    }
    let indexOf = srcColumn.findIndex((issue) => issue.id === issueData.id);
    const removedItem = srcColumn.splice(indexOf, 1);
    targetColumn.splice(dropped.currentIndex, 0, removedItem[0]);
    try {
      const payload = {
        status: newStatus,
        display_order: newOrder
      }
      await this.updateIssueStatus(issueData.id, payload);
      issueData.status = newStatus;
      if(newStatus === 'done') {
        setTimeout(() => this.throwConfetti(issueData.id), 100);
      }
    } catch (err) {
      // Revert the changes
      indexOf = targetColumn.findIndex((issue) => issue.id === issueData.id);
      const movedItem = targetColumn.splice(indexOf, 1);
      srcColumn.push(movedItem[0]);
      this.errorMessage = (err.error && err.error.message) ? err.error.message : err.message;
    }
    this.storage.delete('tasksLastSavedAt');
    this.issuesColumns[dropped.previousContainer.id] = [...this.issuesColumns[dropped.previousContainer.id]];
    this.issuesColumns[dropped.container.id] = [...this.issuesColumns[dropped.container.id]];
  }

  async updateIssueStatus(issueId, payload) {
    await this.reportIssue.updateIssueReport(issueId, payload);
    this.storage.delete('tasksLastSavedAt');
  }

  async throwConfetti(issueiD) {
    const element = this.elementRef.nativeElement.querySelector(`#issue-card-${issueiD}`);
    if (!element) {
      return;
    }
    const rect = element.getBoundingClientRect();
    const xPercent = ((rect.right - 200 ) / window.innerWidth);
    const yPercent = (rect.top / window.innerHeight);
    const canvas = this.renderer2.createElement('canvas');
    canvas.addEventListener('click', () => canvas.style.display = 'none');
    this.renderer2.appendChild(this.elementRef.nativeElement, canvas);
    const confettiAnimation = confetti.create(canvas, { resize: true });
    await confettiAnimation(spookyConfetti({
      particleCount: 25,
      origin: { x: xPercent, y: yPercent },
    }))
    this.renderer2.removeChild(this.elementRef.nativeElement, canvas);
  }

  getUserIcon(assignedUsers) {
    if (!assignedUsers?.length) {
      return '';
    }
    const conciergeUser = assignedUsers.find((user) => user.id === 0);
    if (conciergeUser) {
      return 'concierge';
    } else {
      return 'user';
    }
  }

  getIssueDueDate(dueDate) {
    return new ParseDateTimePipe().transform(dueDate, 'MMM d');
  }

  isDueDateInPast(dueDate) {
    const now = LuxonDateTime.local();
    return LuxonDateTime.fromISO(dueDate) < now;
  }

  trackByFn(index, item) {
    return item.id; // or any unique property
  }

  trackByIssue(index, issue) {
    return issue.id; // ensures issues are only re-rendered if their id changes
  }

  trackByColumn(index: number, column: string): string {
    return column;
  }

  trackByUser(index: number, user: any): any {
    return user?.id || index;
  }

  trackByUrgency(index: number, urgency: any): any {
    return urgency?.value || index;
  }

  trackByAddress(index: number, address: any): any {
    return address?.value || index;
  }

  trackByJob(index: number, job: any): any {
    return job?.id || index;
  }

  getActivityDescription(activity: any, userName: string): string {
    try {
      let description = activity?.description;
      if (activity?.data?.old_params) {
        const changes = Object.keys(activity.data.old_params).map(key => {
          let formattedKey = this.formatKey(key);
          let oldKey = activity.data.old_params[key];
          let newKey = activity.data.new_params[key];
          if (key === 'address_id') {
            formattedKey = 'Address';
            const _oldAddress = this.addressResponse.find((address) => address.id === oldKey);
            const _newAddress = this.addressResponse.find((address) => address.id === newKey);
            oldKey = this.getAddressName({ address_id: oldKey });
            newKey = this.getAddressName({ address_id: newKey });
          }
          if (key === 'issue_report_type_id') {
            formattedKey = 'Type';
            oldKey = this.issueReportTypes?.find((type) => type.id === oldKey)?.name;
            newKey = this.issueReportTypes?.find((type) => type.id === newKey)?.name;
          }
          if (key === 'status') {
            oldKey = getTaskStatusLabel(oldKey);
            newKey = getTaskStatusLabel(newKey);
          }
          if (key === 'archived_at') {
            const formattedDate = `${new ParseDateTimePipe().transform(newKey, 'MMM d')  } ${  new ParseDateTimePipe().transform(newKey, 'h:mma')}`;
            if (formattedDate === 'invalid datetime' || newKey === null) {
              const parsedCreatedAt = `${new ParseDateTimePipe().transform(activity.created_at, 'MMM d')  } ${  new ParseDateTimePipe().transform(activity.created_at, 'h:mma')}`;
              return `${userName} unarchived the task at ${parsedCreatedAt}`;
            }
            return `${userName} archived the task at ${formattedDate}`;
          }
          if (key === 'due_date') {
            const newDate = new ParseDateTimePipe().transform(newKey, 'MMM d');
            if (oldKey === '' || oldKey === null) {
              return `${userName} updated field ${formattedKey} to ${newDate}`;
            }
            const oldDate = new ParseDateTimePipe().transform(oldKey, 'MMM d');
            return `${userName} updated field ${formattedKey} from ${oldDate} to ${newDate}`;
          }
          if (oldKey === '' || oldKey === null) {
            return `${userName} updated field ${formattedKey} to ${newKey}`;
          }
          if (newKey === '' || newKey === null) {
            return `${userName} cleared field ${formattedKey}`;
          }
          return `${userName} updated field ${formattedKey} from ${oldKey} to ${newKey}`;
        }).join(', ');
        description = changes || description;
      }
      if (activity?.activity_type === 'create_file') {
        description = `${userName} uploaded a file`;
      }
      if (activity?.activity_type === 'create_attachment') {
        description = `${userName} added an attachment`;
      }
      if (activity?.activity_type === 'delete_file') {
        description = `${userName} deleted a file`;
      }
      if (activity?.activity_type === 'delete_attachment') {
        description = `${userName} deleted an attachment`;
      }
      if (activity?.activity_type === 'comment') {
        description = `${activity?.data?.content}`;
      }
      return description;
    } catch (_error) {
      return '';
    }
  }

  formatKey(key: string): string {
    return key.split('_').map(word => word.charAt(0).toUpperCase() + word.slice(1)).join(' ');
  }

  getInitials(name) {
    if (!name) {return 'BA';}
    return name.split(' ').map(part => part[0]).join('').toUpperCase();
  }

  async exportCSV() {
    if (!this.loggedIssuesResponse || this.loggedIssuesResponse.length === 0) {
      return this.util.showError('No data to export', 5000);
    }

    try {
      const fullIssuesData = await this.reportIssue.getIssueReportsForExport();
      if (!Array.isArray(fullIssuesData)) {
        throw new Error('Export response was not an array');
      }

      const statusOrder = { 'reported': 1, 'approved': 2, 'in_progress': 3, 'done': 4 };
      const sortedTasks = [...fullIssuesData].sort((a, b) => {
        const statusDiff = (statusOrder[a.status] ?? 99) - (statusOrder[b.status] ?? 99);
        if (statusDiff !== 0) {return statusDiff;}
        return (a.display_order ?? 0) - (b.display_order ?? 0);
      });

      const headers = ['Title', 'Description', 'Type', 'Property', 'Urgency', 'Due Date', 'Reporter Name', 'Member', 'Status', 'Order', 'Photos', 'Activity', 'Jobs', 'Items'];

      const rows = sortedTasks.map(task => {
        const members = task?.checkedUsers?.map((user) => `${user?.name}`).join(', ') || '';
        const propertyName = this.getAddressName(task) || '';
        const typeName = new TitleCasePipe().transform(task.issue_report_type?.name?.replace('_', ' ') || '') || '';
        const photosCount = task.photos?.length || 0;
        const activityDescriptions = task.activities?.map((activity) => {
          const userName = `${activity?.by_user?.first_name} ${activity?.by_user?.last_name}`;
          return this.getActivityDescription(activity, userName);
        }).join('; ') || '';
        const jobs = task?.checkedJobs?.map((job) => `${job?.service_name} ${job?.name}`).join(', ') || '';
        const items = task?.room_objects?.map((item) => item.name).join(', ') || '';

        return [
          task.title || '',
          task.description || '',
          typeName,
          propertyName,
          task.urgency || '',
          task.due_date || '',
          task.reporter_name || '',
          members,
          task.status || '',
          task.display_order ?? '',
          photosCount,
          activityDescriptions,
          jobs,
          items,
        ];
      });

      this.downloadCsvFile('tasks-export.csv', headers, rows);
    } catch (err) {
       
      console.error('exportCSV failed', err);
      this.errorMessage = (err?.error && err.error.message) ? err.error.message : err?.message;
      this.util.showError('Failed to export CSV data', 5000);
    }
  }

  private downloadCsvFile(filename: string, headers: string[], rows: (string | number)[][]): void {
    const escape = (value: unknown): string => {
      const str = value === null || value === undefined ? '' : String(value);
      if (/[",\n\r]/.test(str)) {
        return `"${str.replace(/"/g, '""')}"`;
      }
      return str;
    };
    const lines = [headers.map(escape).join(',')];
    rows.forEach(row => lines.push(row.map(escape).join(',')));
    const BOM = '﻿';
    const blob = new Blob([BOM + lines.join('\r\n')], { type: 'text/csv;charset=utf-8;' });
    const url = URL.createObjectURL(blob);
    try {
      const link = document.createElement('a');
      link.href = url;
      link.download = filename;
      link.rel = 'noopener';
      link.style.display = 'none';
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    } catch (err) {
       
      console.error('CSV download click failed, falling back to window.open', err);
      window.open(url, '_blank');
    } finally {
      setTimeout(() => URL.revokeObjectURL(url), 1000);
    }
  }

  async goToAddJob(issue) {
    if (this.demoBlock.block()) { return; }
    localStorage.setItem('addressId', issue.address_id);
    this.closeAllMenus();
    this.storage.save('bookJobBackPage', 'tasks');
    const params = {
      isSelectingAddressToBook: true,
      bookingType: 'add_job'
    };
    await this.bookService.goToBookJob(params);
    this.rightSidePanelService.afterPanelClosed()
      .pipe(take(1), takeUntilDestroyed(this.destroyRef))
      .subscribe(async () => {
        this.showLoadingSpinner = true;
        await this.getData(true, true);
        this.showLoadingSpinner = false;
      });
  }

  async goToJob(job, issue) {
    if (this.demoBlock.block()) { return; }
    localStorage.setItem('jobBackPage', 'tasks');
    const pastJobStatuses = ['completed', 'cancelled'];
    const isPastJob = pastJobStatuses.includes(job?.job_data?.job_progress) || job?.isPastJob;
    if (this.windowService.isDesktopRes) {
      const updatedParams = {
        job,
        jobId: job?.job_id,
        isPastJob,
        isPrivateJob: job?.is_private,
        addressId: issue.address_id
      };
      await this.storage.save('dialog-right-side-open', true);
      await this.storage.save('dialog-params', updatedParams);
      this.navigateToJobPageInsideDialog(isPastJob, job.is_private);
      return;
    }
    if (isPastJob) {
      if (job.is_private) {
        this.navCtrl.navigateForward(`past-private-job/${job.job_id}`);
      } else {
        this.navCtrl.navigateForward(`past-job/${job.job_id}`);
      }
    } else {
      const params = {
        jobId: job?.job_id,
        addressId: issue.address_id
      };
      this.navCtrl.navigateForward(`job/${issue.address_id}/${job.job_id}`, params);
    }
  }

  navigateToJobPageInsideDialog(isPastJob: boolean, isPrivateJob: boolean): void {
    if (isPastJob && isPrivateJob) {
      this.rightSidePanelService.openRightSidePanel(PastPrivateJobPage);
    } else if (isPastJob) {
      this.rightSidePanelService.openRightSidePanel(PastJobPage);
    } else {
      this.rightSidePanelService.openRightSidePanel(JobPage);
    }
    this.rightSidePanelService.panelClosed().pipe(take(1), takeUntilDestroyed(this.destroyRef)).subscribe(async () => {
      this.showLoadingSpinner = true;
      await this.getData(true, true);
      this.showLoadingSpinner = false;
    });
  }

  updateJobSearch({ search }) {
    if (!this.issuesColumns) {return;}
    this.columns.forEach((column) => {
      if (Array.isArray(this.issuesColumns[column])) {
        this.issuesColumns[column].forEach((issue) => {
          if (issue.allJobs) {
            if (search.length < 2 || search === '') {
              issue.filteredJobs = [...issue.allJobs];
            } else {
              const term = search.toLowerCase();
              issue.filteredJobs = issue.allJobs.filter((job) => (job.name && job.name.toLowerCase().includes(term)) ||
                       (job.service_name && job.service_name.toLowerCase().includes(term)));
            }
          }
        });
      }
    });
  }

  focusJobSearchInput() {
    this.jobSearchForm.patchValue({ search: '' });
    try {
      // Look for search inputs in overlay containers (mat-menu)
      const overlayInputs = document.querySelectorAll('.cdk-overlay-pane .search-input');
      if (overlayInputs.length > 0) {
        const lastInput = overlayInputs[overlayInputs.length - 1] as HTMLInputElement;
        lastInput.focus();
        lastInput.select();
        return;
      }

      // Fallback: look for any text inputs in overlay that might be search inputs
      const overlayAllInputs = document.querySelectorAll('.cdk-overlay-pane input[type="text"]');
      if (overlayAllInputs.length > 0) {
        const lastInput = overlayAllInputs[overlayAllInputs.length - 1] as HTMLInputElement;
        if (lastInput.placeholder && lastInput.placeholder.includes('Search')) {
          lastInput.focus();
          lastInput.select();
          return;
        }
      }
    } catch (_err) {
      // Silent error handling - focus search input failure is not critical
    }
  }

  closeAllMenus() {
    try {
      const overlayBackdrops = document.querySelectorAll('.cdk-overlay-backdrop');
      overlayBackdrops.forEach(backdrop => {
        (backdrop as HTMLElement).click();
      });
    } catch (_err) {
      // Silent error handling - close menus failure is not critical
    }
  }

  ngAfterViewInit() {
    // Set up keyboard prevention for all job menu triggers
    const jobMenuTriggers = [
      this.desktopJobMenuTrigger,
      this.desktopJobMenuTrigger2,
      this.mobileJobMenuTrigger
    ];

    jobMenuTriggers.forEach(trigger => {
      if (trigger) {
        trigger.menuOpened.subscribe(() => {
          this.preventMenuCloseOnKeyboard(trigger);
        });
      }
    });
  }

  preventMenuCloseOnKeyboard(menuTrigger: MatMenuTrigger) {
    // Store original closeMenu function
    const originalCloseMenu = menuTrigger.closeMenu.bind(menuTrigger);
    let isKeyboardOpen = false;

    // Detect keyboard open/close on mobile
    const onFocusIn = () => {
      isKeyboardOpen = true;
    };

    const onFocusOut = () => {
      setTimeout(() => {
        isKeyboardOpen = false;
      }, 100);
    };

    // Add listeners to detect focus (keyboard opening)
    document.addEventListener('focusin', onFocusIn);
    document.addEventListener('focusout', onFocusOut);

    // Override closeMenu to prevent closing when keyboard opens
    menuTrigger.closeMenu = () => {
      // Only allow closing if keyboard is not open or if explicitly closed by user
      if (!isKeyboardOpen) {
        originalCloseMenu();
      }
    };

    // Cleanup when menu closes
    menuTrigger.menuClosed.subscribe(() => {
      document.removeEventListener('focusin', onFocusIn);
      document.removeEventListener('focusout', onFocusOut);
      menuTrigger.closeMenu = originalCloseMenu;
    });
  }

  async checkForAssets() {
    try {
      const response = await this.genome.getInventoryRoomObjects({ page: 1, per_page: 1 });
      this.hasAssets = parseInt(response.totalRecords, 10) > 0;
    } catch (err) {
      this.hasAssets = false;
    }
  }

  async fetchMaintenanceSuggestions() {
    try {
      this.maintenanceSuggestions = await this.maintenanceSuggestionsService.getMaintenanceSuggestions();
    } catch (err) {
      this.maintenanceSuggestions = [];
    }
  }

  async goToSuggestion(suggestion: MaintenanceSuggestion) {
    if (this.demoBlock.block()) { return; }
    const params = {
      suggestion
    };
    this.storage.save('dialog-right-side-open', true);
    this.storage.save('dialog-params', params);
    if (this.windowService.isDesktopRes) {
      this.rightSidePanelService.openRightSidePanel(SuggestionPage);
      this.rightSidePanelService.setDialogPageTitle('Suggested Maintenance');
      this.rightSidePanelService.panelClosed().pipe(
        take(1),
        takeUntilDestroyed(this.destroyRef)
      ).subscribe(async () => {
        const tasksLastSavedAt = await this.storage.retrieve('tasksLastSavedAt');
        if (!tasksLastSavedAt) {
          await this.fetchMaintenanceSuggestions();
          await this.getLoggedIssues();
          await this.parseUsersAndJobs();
        }
      });
    } else {
      this.navCtrl.navigateForward('suggestion');
    }
  }

  async rejectSuggestion(suggestion: MaintenanceSuggestion) {
    if (this.demoBlock.block()) { return; }
    try {
      await this.maintenanceSuggestionsService.rejectSuggestion(suggestion.id);
      this.maintenanceSuggestions = this.maintenanceSuggestions.filter(s => s.id !== suggestion.id);
    } catch (err) {
      this.util.showError('Failed to reject suggestion');
    }
  }

  goToAssets() {
    this.navCtrl.navigateForward('assets');
  }

  ngOnDestroy(): void {
    localStorage.removeItem('maintenanceAddressId');
  }

}
